import * as filterReducers from './filter.reducers';
import * as currentFilterReducers from './current-filter.reducers';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

export interface FiltersReducersState {
  data: filterReducers.FilterState;
  currentFilters: any;
}

export const reducers: ActionReducerMap<FiltersReducersState> = {
  data: filterReducers.reducer,
  currentFilters: currentFilterReducers.reducer,
};

export const getFilterState = createFeatureSelector<FiltersReducersState>('filters');
